<script>
	import Grass from '../../assets/EggHunt/Grass.png'
	import Sky from '../../assets/EggHunt/Background - Sky.png'
	import EggHuntLogo from '../../assets/EggHunt/Egg Hunt Logo.png'
	import EmailBox from './EmailBox.svelte'

  export let initialHeight;
  export let headerHeight;
</script>

<div class='w-100 flex flex-column items-center justify-between' style={'left:0px; top:0px; height: ' + (initialHeight - headerHeight) +'px'} >
  <div class='w-100 bg-black happy-yellow pv1 pv2-ns fw7 f4 bb b--dark-gray tc'><h1 class='fw7 f4'>Next Event: The 250th Coin Hunt</h1></div>
	<div class='relative w-100 overflow-hidden egg-hunt-container'>
		<!-- Sky background -->
		<img
			src={Sky}
			alt='Blue sky with fluffy clouds'
			class='absolute top-0 left-0 w-100 h-100'
			style='object-fit: cover; z-index: 0;'
		/>

		<!-- Center logo + button -->
		<div class='relative w-100 h-100 flex flex-column items-center justify-center' style='z-index: 1;'>
      <a 
        href='https://egg.scavengergames.com'
        target='_blank'
        rel='noreferrer'
        class='egg-logo'
      >
        <img
          src={EggHuntLogo}
          alt='The Great Egg Hunt logo'
        />
      </a>
			<div class=''>
				<a
					class='pv3 ph4 br3 bg-light-purple white fw7 f4 pointer link ba b--white bw1'
					href='https://egg.scavengergames.com'
					target='_blank'
					rel='noreferrer'
				>
					Learn More
				</a>
			</div>
		</div>

		<!-- Grass at the bottom -->
		<img
			src={Grass}
			alt='Grass along the bottom'
			class='absolute left-0 w-100 grass'
			style='bottom: 0; z-index: 2; pointer-events: none;'
		/>
	</div>
</div>

<style>
	.egg-hunt-container {
		height: 100%;
		min-height: 360px;
	}

	.egg-logo {
    margin-bottom: 50px;
		max-height: 75%;
		max-width: 55%;
		animation: egg-pulse 2.5s ease-in-out infinite;
		transform-origin: center center;
		filter: drop-shadow(0 0 8px rgba(0, 153, 255, 0.6))
			drop-shadow(0 0 16px rgba(0, 153, 255, 0.4));
	}

	.grass {
		transform: scale(3);
		transform-origin: bottom center;
	}

	@media (min-width: 40rem) {
		.grass {
			transform: scale(1);
		}
	}

	@keyframes egg-pulse {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.07);
		}
		100% {
			transform: scale(1);
		}
	}
</style>